import React from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from 'styled-components'
import createTheme from './assets/styles/createTheme'
import Routes from './Routes'
import configureStore from './store/store'
import { Provider } from 'react-redux'
import {ApolloClient, InMemoryCache, ApolloProvider, HttpLink} from '@apollo/client'
import {setContext} from '@apollo/client/link/context'
import {onError} from '@apollo/client/link/error'
import {getGuestTokenName, getUserTokenName} from '@/utils/tokenUtils'
import {SET_USER_AUTH_ERROR} from '@/store/types'
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components'

if (!window.env?.REACT_APP_BASE_URL) {
    throw new Error('REACT_APP_BASE_URL is missing - env.js not loaded?')
}
const isLocal = window.location.hostname === 'localhost'
export const BE_BASE_URL = isLocal ? '' : window.env.REACT_APP_BASE_URL

console.log('REACT_APP_BASE_URL from ENV is: ' + window.env.REACT_APP_BASE_URL)

const { store } = configureStore()

const httpLink = new HttpLink({uri: BE_BASE_URL + '/graphql'})
const authLink = setContext((_, {headers}) => {
    const token = sessionStorage.getItem(getUserTokenName()) || sessionStorage.getItem(getGuestTokenName())

    return {
        headers: {
            ...headers,
            authorization: `Bearer ${token}`
        }
    }
})

const errorLink = onError(({networkError}) => {
    if (networkError) {
        const err: any = networkError
        if(err.statusCode === 403) {
            store.dispatch(SET_USER_AUTH_ERROR(true))
        }
    }
})

const client = new ApolloClient({
    link: errorLink.concat(authLink.concat(httpLink)),
    cache: new InMemoryCache(),
})

function App() {
    const theme = createTheme()

    return (
        <Provider store={store}>
            <ApolloProvider client={client}>
                <ThemeProvider theme={theme}>
                    <StyledComponentsThemeProvider theme={theme}>
                        <CssBaseline />
                        <Routes />
                    </StyledComponentsThemeProvider>
                </ThemeProvider>
            </ApolloProvider>
        </Provider>
    )
}

export default App
